<!--
 * @Author: 胡彩丽 hucaili@qfei.cn
 * @Date: 2023-06-10 18:48:03
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
 * @LastEditTime: 2023-12-07 16:06:04
 * @FilePath: \fe-crm\src\components\public\xl-schedule\xl-update-schedule\xl-update-schedule.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->

<template>
  <div class="page-comp-clue-new-trip">
    <!-- width="600px" -->
    <jw-modal :visible="visible" @ok="handleOk" @cancel="handleCancel" title-align="start" :mask-closable="false" unmount-on-close :ok-loading="loading">
      <template #title> {{ typeTitle }}</template>
      <jw-form :model="form" label-align="left" ref="newTripForm" @submit="handleSubmit">
        <jw-form-item v-if="sourceType === 'workschedule'" field="saleClueId" sterisk-position="end" :rules="{ required: true, message: '客户名称是必填项' }" :validate-trigger="['blur', 'input']" :label-col-style="{ width: '110px' }" class="form-label-text">
          <template #label>
            <xl-label-text :value="$t('客户名称')" :row="1" />
          </template>
          <jw-select :style="{ width: '320px' }" v-model="form.saleClueId" :placeholder="$t('请搜索客户名称并选择')" @search="handleSearch" allow-search allow-clear :filter-option="false" :loading="searchLoading" :virtual-list-props="{ height: 200 }" :options="companyOptions" :trigger-props="{ contentStyle: { width: '100%' }, contentClass: 'calendar-content-add-popup' }" @clear="handleSearch" @change="changeCustomer">
            <template #option="{ data }">
              <jw-space size="mini" direction="vertical" fill :title="data?.label">
                <div class="client-option-title">
                  <icon-idcard />
                  <span>
                    {{ data?.label || '-' }}
                  </span>
                </div>
                <div class="client-option-slot">
                  <jw-space> {{ $t('对象') }}：{{ entityObj[data.entity]?.name }} </jw-space>
                  <jw-space> {{ entityObj[data.entity]?.label || '' }}：{{ data?.business || '' }} </jw-space>
                </div>
              </jw-space>
            </template>
            <!-- <jw-option v-for="item of companyOptions" :key="item.value" :value="item.value"></jw-option> -->
          </jw-select>
        </jw-form-item>
        <jw-form-item field="summary" asterisk-position="end" :rules="{ required: true, message: $t('日程主题是必填项') }" :validate-trigger="['blur', 'input']" :label-col-style="{ width: '110px' }" class="form-label-text">
          <template #label>
            <xl-label-text :value="$t('日程主题')" :row="1" />
          </template>
          <jw-input v-model="form.summary" :placeholder="$t('输入日程主题')" :style="{ width: '320px' }" />
        </jw-form-item>
        <jw-form-item field="dateTime" asterisk-position="end" :rules="followTimeRules" required :label-col-style="{ width: '110px' }" class="form-label-text">
          <template #label>
            <xl-label-text :value="$t('跟进时间')" :row="1" />
          </template>
          <jw-date-picker v-model="form.dateTime[0]" :allow-clear="false" :style="{ width: '125px', marginRight: '10px' }" />
          <!-- <jw-time-picker v-model="form.dateTime[1]" :allow-clear="false" :step="{ minute: 15 }" disable-confirm format="HH:mm" type="time-range" :style="{ width: '185px' }" /> -->
          <div :style="{ backgroundColor: 'var(--color-fill-2)', borderRadius: 'var(--border-radius-small)' }">
            <jw-time-picker v-model="form.dateTime[1][0]" :step="{ minute: 15 }" disable-confirm format="HH:mm" :allow-clear="false" style="width: 85px" @change="startTimeSelect('start', form.dateTime[1][0])" />
            <span>-</span>
            <jw-time-picker v-model="form.dateTime[1][1]" format="HH:mm" :allow-clear="false" :step="{ minute: 15 }" disable-confirm style="width: 85px" @change="startTimeSelect('end', form.dateTime[1][1])" />
          </div>
        </jw-form-item>
        <jw-form-item field="pitchType" asterisk-position="end" :rules="{ required: true, message: '跟进方式是必选项' }" :validate-trigger="['blur', 'input']" :label-col-style="{ width: '110px' }" class="form-label-text">
          <template #label>
            <xl-label-text :value="$t('跟进方式')" :row="1" />
          </template>
          <jw-select v-model="form.pitchType" :placeholder="$t('请选择跟进方式')" :style="{ width: '320px' }" allow-clear allow-search :options="userInfo?.orgId != huaYingOrdId ? followType : hyzbFollowType"> </jw-select>
        </jw-form-item>
        <jw-form-item field="userNames" asterisk-position="end" v-if="!tripEdit" :label-col-style="{ width: '110px' }" class="form-label-text">
          <template #label>
            <xl-label-text :value="$t('参会人')" :row="1" />
          </template>

          <fh-person className="schedule-user-select" position="bl" :item="form" :multiple="true" @cb="getVal" @popup-visible-change="selectVisibleChange" @remove="selectVisibleChange(false)"> </fh-person>

          <!-- <xl-tree-member-modal ref="xlTreeMember" @cb="getVal" :depart="form?.departList" :user="form?.userList" :tree="{ isAll: true }">
            <jw-input-tag v-model="form.userNames" readonly :style="{ width: '320px' }" :max-tag-count="3" :placeholder="$t('请选择人员，仅支持选择租户内人员')" />
          </xl-tree-member-modal> -->
        </jw-form-item>
        <jw-form-item field="userNames" asterisk-position="end" v-else :label-col-style="{ width: '110px' }" class="form-label-text">
          <template #label>
            <xl-label-text :value="$t('参会人')" :row="1" />
          </template>
          <jw-input-tag v-model="form.userNames" readonly :style="{ width: '320px' }" :max-tag-count="3" :placeholder="$t('请选择人员，仅支持选择租户内人员')" disabled />
        </jw-form-item>
      </jw-form>
    </jw-modal>
  </div>
</template>

<script>
import { reactive, toRefs, ref, computed, inject } from 'vue';
import { calendarService } from '@/api/';
import { Message } from '@arco-design/web-vue';
import dayjs from 'dayjs';
import { followType, hyzbFollowType, huaYingOrdId } from '@/utils/const';
import { useScheduleStore, useFollowRecords, useUserStore } from '@/store';
import { useI18n } from 'vue-i18n';
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'ClueNewTrip',
  props: {
    clueId: {
      type: Number
    }
  },
  setup(props, ctx) {
    const { t } = useI18n();
    console.log('1-开始创建组件-setup', props, ctx);
    const { userInfo } = useUserStore();
    const useSchedule = useScheduleStore(); //日程store
    const newTripForm = ref();
    const followRecords = useFollowRecords(); //动态记录
    // 这里是打开新建日程弹窗
    // sourceType=workschedule:从工作日程看板中的大日历组件跳转过去的.schedule:日程跳转来源
    //controlsType：编辑：edit，新增：add
    const updateScheduleShow = (record) => {
      data.sourceType = record.sourceType;
      data.controlsType = record.controlsType;
      data.record = record;
      data.typeTitle = record.typeTitle;
      data.visible = true;
      console.log(48, data.form.dateTime[1]);
      data.form.departList = [];
      data.form.userList = [];
      data.form.userNames = [];
      data.form.saleClueId = '';
      data.companyOptions = [];
      if (data.controlsType === 'add') {
        //新增
        data.tripEdit = false;
        data.form.summary = data.entryName || '';
        data.form.pitchType = '';
        data.form.dateTime[0] = dayjs(new Date()).format('YYYY-MM-DD');
        data.form.dateTime[1] = [dayjs(new Date()).format('HH:mm'), dayjs(new Date().getTime() + 60 * 60 * 1000).format('HH:mm')];
      } else {
        //编辑
        data.tripEdit = true;
        data.form.summary = record?.calenderItem;
        data.form.pitchType = record?.pitchInType;
        data.form.userNames = record?.selfJoinPersonsName?.split(',');
        data.form.dateTime[0] = dayjs(record?.startTime).format('YYYY-MM-DD');
        data.form.dateTime[1] = [dayjs(record?.startTime).format('HH:mm:ss'), dayjs(record?.endTime).format('HH:mm:ss')];
      }
    };
    // 新建日程
    const addCreatEvent = async () => {
      data.loading = true;
      const params = {
        type: data.entityId || data.type,
        id: data.id || data.form?.saleClueId,
        // clueId: data.id || data.form?.saleClueId,
        users: data.form.usersId,
        summary: data.form.summary,
        timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        pitchType: data.form.pitchType,
        startTimestamp: new Date(data.form.dateTime[0] + ' ' + data.form.dateTime[1][0]).getTime() / 1000,
        endTimestamp: new Date(data.form.dateTime[0] + ' ' + data.form.dateTime[1][1]).getTime() / 1000
      };

      console.log('新建日程', params);

      useSchedule
        .addCreatEvent(params)
        .then((res) => {
          console.log(res);
          if (!res.error) {
            ctx.emit('cb');
            handleCancel();
          }
        })
        .finally(() => {
          data.loading = false;
        });
    };
    //刷新动态记录
    const getFollowList = async () => {
      const params = { id: data.id, page: 1, pageSize: 100, type: data.type, isUpdate: true };
      await followRecords
        .getFollowRecords(params)
        .then((res) => {
          console.log(res);
        })
        .finally(() => {});
    };
    // 编辑日程
    const updateCalender = async () => {
      data.loading = true;
      const params = {
        id: data.record.id,
        eventId: data.record.eventId,
        taskId: data.record.taskId,
        calenderId: data.record.calenderId,
        calenderItem: data.form.summary,
        pitchInType: data.form.pitchType,
        startTime: dayjs(data.form.dateTime[0] + ' ' + data.form.dateTime[1][0]).format('YYYY-MM-DD HH:mm:ss'),
        endTime: dayjs(data.form.dateTime[0] + ' ' + data.form.dateTime[1][1]).format('YYYY-MM-DD HH:mm:ss')
      };
      useSchedule
        .updateCreatEvent(params)
        .then((res) => {
          console.log(res);
          if (!res.error) {
            ctx.emit('cb');
            getFollowList();
            handleCancel();
          }
        })
        .finally(() => {
          data.loading = false;
        });
    };
    // 选择开始时间自动改变结束时间
    const startTimeSelect = (type, value) => {
      console.log(283, value);
      const currentTime = data.form.dateTime?.[0] || dayjs(new Date()).format('YYYY-MM-DD');
      if (type === 'start') {
        const startTime = currentTime + '' + value;
        const endTime = currentTime + '' + data.form.dateTime[1][1];
        const time = +dayjs(startTime);
        if (startTime > endTime) {
          console.log('294开始时间大于结束时间', time);
          if (value.split(':')[0] === '23') {
            data.form.dateTime[1][1] = dayjs(time).format('HH:mm');
          } else {
            data.form.dateTime[1][1] = dayjs(time + 60 * 60 * 1000).format('HH:mm');
          }
        }
      } else {
        const startTime = currentTime + '' + data.form.dateTime[1][0];
        const endTime = currentTime + '' + value;
        const time = +dayjs(startTime);
        if (startTime > endTime) {
          data.form.dateTime[1][1] = dayjs(time).format('HH:mm');
        }
      }
    };
    // 确定按钮
    const handleOk = () => {
      newTripForm.value.handleSubmit();
    };
    // 动态记录表单提交
    const handleSubmit = ({ values, errors }) => {
      console.log('values', values);
      console.log('errors', errors);
      if (errors) {
        const errorArray = {};
        Object.values(errors).forEach((key, index) => {
          errorArray[key.field] = { status: 'error', message: '' };
          Object.values(errorArray).forEach((i, ind) => {
            if (index === ind) {
              i.message = key.message;
            }
          });
        });
        newTripForm.value.setFields(errorArray);
        return;
      }
      // 此处调用接口
      if (data.controlsType === 'add') {
        addCreatEvent();
      } else {
        updateCalender();
      }
    };
    //  添加跟进弹窗的取消按钮
    const handleCancel = () => {
      data.visible = false;
      //弹窗关闭被销毁，获取form的ref为null
      newTripForm.value?.resetFields?.(); //清空表单
    };
    // 添加人员角色--获取部门或者用户的值
    const getVal = (v) => {
      // prop为field值，单一清除时使用
      console.log('人员选择查看:', v);
      // 选择人员后，调添加人员接口，参数都在v中，按需去V中取
      const userNames = computed(() => v?.userList?.map((u) => u.userName));
      const usersId = computed(() => v?.userList?.map((u) => u.id));
      console.log('userNames', userNames.value);
      data.form.departList = v.departList;
      data.form.userList = v.userList;
      data.form.userNames = userNames.value;
      data.form.usersId = usersId;
    };
    // 添加日程调用的api 获取公司名称
    const getCompanyNames = async (value) => {
      data.searchLoading = true;
      try {
        const params = { name: value, page: 1 };
        const res = await calendarService.getCompanyList(params);
        data.searchLoading = false;
        console.log('获取线索列表,只需拿到公司名称和线索ID');
        data.companyOptions = res.result || [];
        console.log(149, data.companyOptions);
      } catch (e) {
        data.searchLoading = false;
        Message.error(e.message || e.statusText || t('动态记录数据获取失败'));
      }
    };
    // 客户名称的事件
    const changeCustomer = (v) => {
      console.log(v);
      if (v) {
        const val = data.companyOptions.find((el) => el.value === v);
        if (val) {
          data.form.summary = val?.label;
          data.entityId = val?.entity;
        }
      }
    };
    // 添加日程
    const handleSearch = (value) => {
      console.log(141, value);
      data.form.saleClueId = '';
      data.companyOptions = [];
      if (value) {
        getCompanyNames(value);
      } else {
        data.companyOptions = [];
      }
    };
    // 自定义表单效验规则
    const followTimeRules = [
      {
        validator: (value, cb) => {
          console.log(82, data.form.dateTime, value, cb);
          if (value[0] === undefined || value[1] === undefined) {
            return cb(t('跟进时间为必填项'));
          }
          return;
        }
      }
    ];
    const data = reactive({
      visible: false,
      sourceType: null,
      loading: false,
      searchLoading: false,
      typeTitle: '',
      id: inject('detailParams')?.id || inject('defaultParams')?.id, //客户id
      type: inject('detailParams')?.entity || inject('defaultParams')?.entity,
      entityId: null,
      entryName: inject('detailParams')?.entryName || inject('defaultParams')?.entryName, // 当前类型的名称
      record: {},
      companyOptions: [],
      tripEdit: false,
      form: {
        saleClueId: '',
        summary: '',
        dateTime: [dayjs(new Date()).format('YYYY-MM-DD'), [dayjs(new Date()).format('HH:mm'), dayjs(new Date().getTime() + 60 * 60 * 1000).format('HH:mm')]],
        pitchType: '',
        userNames: [],
        usersId: [],
        departList: [],
        userList: []
      },
      entityObj: {
        1: {
          name: '销售线索',
          label: t('跟进建议')
        },
        2: {
          name: '客户',
          label: t('成交状态')
        },
        3: {
          name: '商机',
          label: t('商机阶段')
        }
      }
    });
    return {
      updateScheduleShow,
      handleCancel,
      newTripForm,
      handleOk,
      handleSubmit,
      followTimeRules,
      getFollowList,
      getVal,
      handleSearch,
      startTimeSelect,
      followType,
      changeCustomer,
      userInfo,
      huaYingOrdId,
      hyzbFollowType,
      ...toRefs(data)
    };
  }
};
</script>
<style scoped lang="less">
@import './xl-update-schedule.less';
</style>
